import { render, staticRenderFns } from "./inquiryDetailProduct.vue?vue&type=template&id=594a165a"
import script from "./inquiryDetailProduct.vue?vue&type=script&lang=js"
export * from "./inquiryDetailProduct.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetailProduct.vue?vue&type=style&index=0&id=594a165a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594a165a')) {
      api.createRecord('594a165a', component.options)
    } else {
      api.reload('594a165a', component.options)
    }
    module.hot.accept("./inquiryDetailProduct.vue?vue&type=template&id=594a165a", function () {
      api.rerender('594a165a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/components/inquiryDetailProduct.vue"
export default component.exports